import { FileButton } from 'components/common/button';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import CursivePinkText from './CursivePinkText';
import PinkText from './PinkText';
import TinyText from './TinyText';

const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

const PaidMedicalReportInfo = () => {
    const { t } = useTranslation('translation');

    const openPdf = () => window.open('/Wniosek_o_udostepnienie_dokumentacji_medycznej.pdf', '_blank');

    return (
        <StyledContainer>
            <span>
                {t('in_case_of')}
                {'\u00A0'}
                <CursivePinkText>{t('medical_report_copy_2')}</CursivePinkText>
                {'\u00A0'}
                {t('form_request')}
                {'\u00A0'}
                <FileButton
                    style={{ display: 'initial', padding: 0 }}
                    onClick={openPdf}
                    width={31}
                    height={41}
                    type="download-file"
                />
            </span>
            <span>
                {t('filled_request_with_bank_transfer')}
                {'\u00A0'}
                <a href="mailto:marlena.sawicka@genevatrust.pl">
                    <PinkText>{t('request_email')}</PinkText>
                </a>
                {'\u00A0'}
                {t('or_traditionally')}
            </span>
            <TinyText>{t('copartnership')}</TinyText>
            <TinyText>{t('postal_code')}</TinyText>
            <TinyText>{t('street')}</TinyText>
            <span>{t('send_payment_to')}</span>
            <span>{t('bank_account')}</span>
            <span>{t('in_transfer_title')}</span>
        </StyledContainer>
    );
};

export default PaidMedicalReportInfo;
